import { render, staticRenderFns } from "./MainComments.vue?vue&type=template&id=039acf46&scoped=true&"
import script from "./MainComments.vue?vue&type=script&lang=js&"
export * from "./MainComments.vue?vue&type=script&lang=js&"
import style0 from "./MainComments.vue?vue&type=style&index=0&id=039acf46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039acf46",
  null
  
)

export default component.exports